import { useGetOneMessagePublicQuery } from 'api/MessagesApi';
import PublicMessage from 'components/PublicMessage/PublicMessage';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import PublicFooter from 'pages/Client/PublicFooter/PublicFooter';
import PublicHeader from 'pages/Client/PublicHeader/PublicHeader';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { selectAuthUser } from 'store/authSlice';
import './MessagePage.css';

export function MessagePage() {
  const user = useSelector(selectAuthUser);

  const { messageContactId, token } = useParams();
  const resolvedMessageContactId = messageContactId || token;
  const { data } = useGetOneMessagePublicQuery(
    { messageContactId: resolvedMessageContactId! },
    { skip: !resolvedMessageContactId }
  );
  const designProps = data?.designProps;

  if (!resolvedMessageContactId) {
    return <div>No message</div>;
  }

  return (
    <div className="message-content-container layout-full-height">
      {user ? <Header /> : <PublicHeader designProps={designProps} />}

      <ContainerComponent className="layout-main-content">
        <PublicMessage messageContactId={resolvedMessageContactId} designProps={designProps} />
      </ContainerComponent>

      {user ? <Footer /> : <PublicFooter designProps={designProps} isCompact />}
    </div>
  );
}
